import React, { useState } from "react";
import { observer } from "mobx-react-lite";

import { langStore, translate } from "@noli/business";

import { Editor_Words } from "@/utils/lang/editor";
import { SubWithTitle } from "@/components/SubPanel/WithTitle";
import { CatPanel } from "./Cat";
import { PresetTypes, PRESET_TYPES } from "@/modules/editor/constant";
import { PresetSwitch } from "@/modules/editor/components/common/PresetTypeSwitch";
import { Divider } from "@chakra-ui/react";
import { ACGPanel } from "./Acg";
import { isAuthUser } from "@/utils/status";

const presetPanelMap: Record<PresetTypes, React.ReactNode> = {
  cat: <CatPanel />,
  acg: <ACGPanel />,
};
const PresetsPanel: React.FC = () => {
  const lang = langStore.tgt;
  const [presetType, setPresetType] = useState<PresetTypes>(!isAuthUser() ? "cat" : "acg");

  return (
    <SubWithTitle title={translate(Editor_Words.presets_panel_title, lang)} h="700px" pb="24px">
      <PresetSwitch
        enableModelTypes={!isAuthUser() ? ["cat"] : PRESET_TYPES}
        direction="column"
        value={presetType}
        onChange={setPresetType}
        mt="16px"
      />
      <Divider mt="16px" mb="4px" borderColor="#4D4D4D" />
      {presetPanelMap[presetType]}
    </SubWithTitle>
  );
};

export default observer(PresetsPanel);
